<template>
    <v-layout justify-center id="login">
      <v-flex xs12 sm6 md3>
        <v-img
          class="mb-2 mt-5"
          src="/img/plas-logo.png"
          contain
          :height="128"
        />
        <div class="text-center mb-4">
          <span class="login-beta">BETA</span>
          <span v-if="latestVersion" class="ml-2 caption grey--text">
            v{{ latestVersion }}
          </span>
        </div>
        <v-card>
          <v-toolbar color="primary" class="text-xs-center">
            <v-toolbar-title class="text-uppercase">{{ $t('LOGIN') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              v-if="!loggedIn"
              id="login-form"
              @submit.prevent="handleLogin"
            >
              <v-text-field
                v-model="username"
                prepend-icon="person"
                name="username"
                :label="$t('LOGIN_OR_EMAIL')"
                type="text"
                autocomplete="off"
              />
              <v-text-field
                v-model="password"
                prepend-icon="lock"
                name="password"
                :label="$t('PASSWORD')"
                type="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            class="pl-3 pr-3 pt-1 pb-1"
          >
            <v-layout justify-center>
              <v-btn
                color="primary"
                type="submit"
                form="login-form"
                :loading="loggingIn"
                :disabled="loggingIn"
              >{{ $t('LOGIN') }}</v-btn>
            </v-layout>
          </v-card-actions>
          <v-card-actions
            class="pl-3 pr-3 pt-1 pb-3"
          >
            <router-link
              :to="{ name: 'reset-password-request' }"
            >
              {{ $t("FORGOT_PASSWORD") }}
            </router-link>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import releases from '../assets/releases.json';
  import { getLatestVersion } from '../utils/version';

  export default {
    name: 'Login',
    data() {
      return {
        username: '',
        password: '',
      };
    },
    computed: {
      ...mapState('auth', ['loggingIn', 'loggedIn']),
      latestVersion() {
        return getLatestVersion(releases);
      },
    },
    methods: {
      ...mapActions('auth', ['login']),
      handleLogin() {
        const { username, password } = this;
        this.login({ username, password });
      },
    },
  };
</script>

<style scoped>
  .login-beta {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: #ffffff;
    background-color: #ff6f00;
    border-radius: 4px;
    padding: 3px 10px;
  }
</style>
